import { TrackingMethod, TrackingProvider } from '../domain/Tracking'

export function formatTrackingProviderName(provider?: TrackingProvider) {
  switch (provider) {
    case TrackingProvider.TT:
      return 'Trucker Tools'
    default:
      return undefined
  }
}

export function formatTrackingMethodName(method?: TrackingMethod) {
  switch (method) {
    case TrackingMethod.ELD:
      return 'ELD'
    case TrackingMethod.API:
      return 'API'
    case TrackingMethod.EDI:
      return 'EDI'
    case TrackingMethod.Mobile:
      return 'Mobile'
    case TrackingMethod.Manual:
      return 'Manual'
    default:
      return undefined
  }
}

export function formatPreferredProviderTagContent(
  method?: TrackingMethod,
  provider?: TrackingProvider
) {
  if (!method) return undefined

  switch (method) {
    case TrackingMethod.ELD:
    case TrackingMethod.Mobile:
      return formatTrackingProviderName(provider)
    case TrackingMethod.API:
    default:
      return 'No provider needed'
  }
}

export function formatFinalizeConnectionButtonText({
  method,
  provider,
  hasErrorUpdate,
  hasPreviousTracking,
}: {
  method?: TrackingMethod
  provider?: TrackingProvider
  hasErrorUpdate?: boolean
  hasPreviousTracking: boolean
}) {
  if (hasErrorUpdate) return 'We could not save, please try again'
  if (hasPreviousTracking) return 'Confirm tracking setup'

  switch (method) {
    case TrackingMethod.ELD:
      return 'Confirm and open Trucker Tools'
    case TrackingMethod.API:
    case TrackingMethod.EDI:
      return 'Confirm and send request'
    case TrackingMethod.Mobile:
    case TrackingMethod.Manual:
      return 'Confirm tracking setup'
  }
}

export function formatFinalizeConnectionStepTitle(hasPreviousTracking: boolean) {
  return hasPreviousTracking ? '3. Confirm preferred method' : '3. Finalize connection'
}

export function formatFinalizeConnectionStepSubtitle(hasPreviousTracking: boolean) {
  return hasPreviousTracking
    ? 'Review and confirm the tracking setup'
    : 'Confirm and finalize the tracking connection'
}
